<template>
    <!-- <div id="my-captcha" oncontextmenu="return false"> -->
    <div id="my-captcha">
        <!-- <div class="np-captcha-container">
            <div class="np-captcha" v-if="captcha && captcha.length">
                <div
                    v-for="(c, i) in captcha"
                    :key="i"
                    :style="{
                        fontSize: getFontSize() + 'px',
                        fontWeight: 800,
                        transform: 'rotate(' + getRotationAngle() + 'deg)',
                    }"
                    class="np-captcha-character"
                >
                {{ c }}
                </div>
            </div>
        </div> -->

        <!-- oncontextmenu="return false" Previene hacer "Inspect" en el browser: -->
        <v-card outlined pb-0 oncontextmenu="return false">
            <v-container>
                <v-layout row justify-space-between>
                    <v-flex shrink>
                        <canvas id="c"></canvas>
                    </v-flex>
                    <v-flex shrink align-self-center>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn color="red" outlined icon @click="createCaptcha" v-on="on">
                                    <v-icon color="red">mdi-autorenew</v-icon>
                                </v-btn>
                            </template>
                            <span>Intentar con otro código</span>
                        </v-tooltip>
                    </v-flex>
                </v-layout>
                <v-layout row justify-space-around>
                    <v-flex srhink>
                        <v-text-field
                            dense
                            color="red darken-1"
                            name="user"
                            label="Escribe el código"
                            type="text"
                            v-model="userText"
                            align-self-center
                            autocomplete="off"
                            hide-details
                        ></v-text-field>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card>
    </div>
</template>

<script>

export default {
    name: 'MyCaptcha',
    data() {
        return {
            captchaLength: 4,
            captcha: [],
            userText: '',
        };
    },
    
    mounted() {

        var c = document.getElementById("c");
        var ctx = c.getContext("2d");
        this.vueCanvas = ctx;

        this.createCaptcha();

        
    },
    
    methods: {
        createCaptcha() {
            let tempCaptcha = "";
            for (let i = 0; i < this.captchaLength; i ++)
            {
                tempCaptcha += this.getRandomCharacter();
            }
            
            this.captcha = tempCaptcha;
            //console.log("captcha = ", this.captcha);

            //this.createImg1();
            //this.createImg2();
            this.createImg3();
        },

        createImg1(){
            this.vueCanvas.beginPath();
            this.vueCanvas.rect(0, 0, 300, 150);
            this.vueCanvas.stroke();
            
            this.vueCanvas.fillStyle = "#FFFFFF";
            this.vueCanvas.fillRect(1, 1, 299, 149);
            this.vueCanvas.stroke();

            this.vueCanvas.fillStyle = "#0000ff"; // blue

            var nextXPos = 25;
            var totalX = 25;

            for (let i = 0; i < this.captcha.length; i ++)
            {
                //console.log("nextXPos = ", nextXPos);

                this.vueCanvas.translate(nextXPos, 0);
                let fontSize = this.getFontSize();
                totalX = nextXPos;
                nextXPos = totalX + (Math.floor(fontSize * 1.1));
                this.vueCanvas.font = fontSize + 'px serif';
                let angle = this.getRotationAngle() * Math.PI / 180;
                this.vueCanvas.rotate(angle);
                this.vueCanvas.fillText(this.captcha[i], 0, 100);
                this.vueCanvas.rotate(-angle);
                this.vueCanvas.translate(-totalX, 0);
            }
        },

        createImg2(){
            var fontSize = "30px";
            var fontFamily = "Arial";
            var width = 150;
            var height = 50;
            //tamaño
            this.vueCanvas.canvas.width = width;
            this.vueCanvas.canvas.height = height;
            //color de fondo
            this.vueCanvas.fillStyle = "whitesmoke";
            this.vueCanvas.fillRect(0, 0, width, height);
            //puntos de distorsion
            this.vueCanvas.setLineDash([7, 10]);
            this.vueCanvas.lineDashOffset = 5;
            this.vueCanvas.beginPath();
            var line;
            for (var i = 0; i < (width); i++) {
                line = i * 5;
                this.vueCanvas.moveTo(line, 0);
                this.vueCanvas.lineTo(0, line);
            }
            this.vueCanvas.stroke();
            //formato texto
            this.vueCanvas.direction = 'ltr';
            this.vueCanvas.font = fontSize + " " + fontFamily;
            //texto posicion
            var x = (width / 9);
            var y = (height / 3) * 2;
            //color del borde del texto
            this.vueCanvas.strokeStyle = "blue";
            this.vueCanvas.strokeText(this.captcha, x, y);
            //color del texto
            this.vueCanvas.fillStyle = "red";
            this.vueCanvas.fillText(this.captcha, x, y);
        },

        createImg3(){
            var width = 150;
            var height = 50;
            //Tamaño:
            this.vueCanvas.canvas.width = width;
            this.vueCanvas.canvas.height = height;
            //Color de fondo:
            var my_gradient = this.vueCanvas.createLinearGradient(0, 0, width, height);
            my_gradient.addColorStop(0, this.getColorStop());
            my_gradient.addColorStop(1, this.getColorStop());
            this.vueCanvas.fillStyle = my_gradient;
            this.vueCanvas.fillRect(0, 0, width, height);
            //puntos de distorsion
            /*this.vueCanvas.setLineDash([7, 10]);
            this.vueCanvas.lineDashOffset = 5;
            this.vueCanvas.beginPath();
            var line;
            for (var i = 0; i < (width); i++) {
                line = i * 5;
                this.vueCanvas.moveTo(line, 0);
                this.vueCanvas.lineTo(0, line);
            }
            this.vueCanvas.stroke();*/
            
            //Formato del texto:
            //this.vueCanvas.direction = 'ltr';
            
            //Posición del texto:
            var x = (width / 9);
            var y = (height / 3) * 2;
            
            this.vueCanvas.strokeStyle = "blue";
            for (let i = 0; i < this.captcha.length; i ++)
            {
                let angle = this.getRotationAngle() * Math.PI / 180;
                this.vueCanvas.rotate(angle);

                let fontSize = this.getFontSize();
                let fontWeight = this.getWeight();
                let font = fontWeight + ' ' + fontSize + 'px serif';
                this.vueCanvas.font = font;

                //Borde del texto:
                this.vueCanvas.strokeStyle = "red";
                this.vueCanvas.strokeText(this.captcha[i], x, y);

                //Texto:
                this.vueCanvas.fillStyle = "black";
                this.vueCanvas.fillText(this.captcha[i], x, y);

                x += (this.vueCanvas.measureText(this.captcha[i]).width * 1.4);
                this.vueCanvas.rotate(-angle);
            }
        },

        getWeight() {
            const weight = ["", "italic", "bold", "italic bold"];
            const randomNumber = Math.floor(Math.random() * 4);
            return weight[randomNumber];
        },

        getColorStop() {
            const colors = ["pink",
                            "grey", 
                            "SlateGrey",
                            "SkyBlue",
                            "LightGreen",
                            "MediumOrchid",
                            "IndianRed",
                            "Tan",
                            "Thistle",
                            "Orchid",
                            "Plum",
                            "LightCyan",
                            "Lavender",
                            "Salmon",
                            "LightSalmon",
                            "DarkSalmon",
                            "Violet",
                            "LightCoral",
                            "Khaki",
                            "Azure",
                            "white",
                            "cyan",
                            "silver",
                            "purple",
                            "teal",
                            "aqua"];
            const randomNumber = Math.floor(Math.random() * 26);
            return colors[randomNumber];
        },

        getRandomCharacter() {
            const symbols = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
            const randomNumber = Math.floor(Math.random() * 62);
            /*const symbols = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
            const randomNumber = Math.floor(Math.random() * 36);*/
            return symbols[randomNumber];
        },

        getFontSize() {
            const fontVariations = [24, 26, 28, 30, 32, 34, 36, 38, 40];
            return fontVariations[Math.floor(Math.random() * 9)];
        },

        getRotationAngle() {
            const rotationVariations = [0, 2, 4, 6, -2, -4, -6];
            return rotationVariations[Math.floor(Math.random() * 7)];
        },

        onUserTextChanged() {
            if(this.captcha === this.userText)
            {
                this.captchaOK = true;
            }
            else
            {
                this.captchaOK = false;
            }
        },
    },
    computed: {
        captchaOK: {
            get() {
                return this.$store.getters.captchaOK;
            },
            set(captchaOK) {
                this.$store.dispatch('updateCaptchaOK', captchaOK);
            },
        },

        submittingRecaptcha: {
            get() {
                return this.$store.getters.submittingRecaptcha;
            },
            set(submittingRecaptcha) {
                this.$store.dispatch('updateSubmittingRecaptcha', submittingRecaptcha);
            },
        },
    },
    watch: {
        userText: function(value, oldValue) {
            if(this.captcha === this.userText)
            {
                this.captchaOK = true;
            }
            else
            {
                this.captchaOK = false;
            }
        },

        captcha: function(value, oldValue) {
            if(this.captcha === this.userText)
            {
                this.captchaOK = true;
            }
            else
            {
                this.captchaOK = false;
            }
        },
    }
}

</script>

<style scoped>
#my-captcha {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #000000;
    /* margin-top: 60px; */
}
/* .np-captcha-container {
    background: #eee;
    width: 300px;
    margin: 0 auto;
    margin-bottom: 20px;
} */
/* .np-captcha {
    font-size: 24px;
} */

/* .np-captcha-character {
    display: inline-block;
    letter-spacing: 14px;
} */

</style>